import { render, staticRenderFns } from "./edc-form-history-list.vue?vue&type=template&id=2c8e0b69&"
import script from "./edc-form-history-list.vue?vue&type=script&lang=js&"
export * from "./edc-form-history-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edc-form-history-list.vue"
export default component.exports